import { useEffect } from 'react';
import { loadScript } from '@ecs/tng-common/scripts/helpers';

export const useInfogramScript = (ifInfogramExists: boolean) => {
  useEffect(() => {
    if (!ifInfogramExists) return;
    const scriptSrc = 'https://e.infogram.com/js/dist/embed-loader-min.js';
    const scriptId = 'infogram-async';

    loadScript(scriptSrc, scriptId)
      .then(() => {
        const t = 'InfogramEmbeds';
        if (window && window[t as keyof Window] && window[t as keyof Window].initialized) {
          (window[t as keyof Window] as any).process &&
            (window[t as keyof Window] as any).process();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });
};
export const useQSScript = (ctaQuinn: string | null) => {
  useEffect(() => {
    if (!ctaQuinn) return;
    const scriptSrc = `${process.env.QS_HOST}/listingdisplay/loader/sh`;
    const scriptId = 'qs-async';

    loadScript(scriptSrc, scriptId)
      .then(() => {
        // console.log('script loaded');
      })
      .catch((error) => {
        console.error(error);
      });
  });
};
export const useQuidgetScript = (hasQuidget: boolean) => {
  useEffect(() => {
    if (!hasQuidget) return;
    const scriptSrc = `${process.env.QUIDGET_HOST}`;
    const scriptId = 'quidget-async';

    loadScript(scriptSrc, scriptId)
      .then(() => {
        // console.log('script loaded');
      })
      .catch((error) => {
        console.error(error);
      });
  });
};
